export default "__VITE_ASSET__DurUTj7M__"